export default "__VITE_ASSET__623f5b50__"